import styled from "styled-components";

export const Breadcrumb = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    fill: #08a0a0;
  }
`;
